<script setup lang="ts">
import { t } from 'i18next';
import { SubmitButtonProps } from '../types';
import Button from '@/components/buttons/Button.vue';

const { text = t('SaveAndClose') } = defineProps<SubmitButtonProps>();
</script>

<template>
  <Button type="submit" variant="primary" v-bind="$props" :label="text" />
</template>
